<template>
  <div>
    <div id="kub-draft-summary" class="kub-color my-2">
      {{formType}}
      <span v-if="formComplete && (formType === forms.dreieck.type[0].name)">(Höhe {{formSize.h}} cm)</span>
      <span v-if="formComplete && (formType === forms.trapez.type[0].name)">(Höhe {{formSize.h}} cm)</span>
      <span v-if="formComplete && (formType === forms.kreis.type[0].name)">(Durchmesser {{formSize.d}} cm)</span>
      <span v-if="formComplete && (formType === forms.halbkreis.type[0].name)">(Durchmesser {{formSize.d}} cm)</span>
    </div>
    <p v-if="formComplete" class="font-weight-normal kub-color">{{materialType}} <br>{{materialColor.color}}</p>
    <div class="d-flex justify-content-center">
      <svg class="kub-draft-svg" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
        <component :is="draftFormType"></component>
      </svg>
    </div>
  </div>
</template>

<script>
import DataForm from '../../../../data/main/config/setup/form/forms'

import { mapGetters } from 'vuex'

import Rechteck from './forms/Rechteck.vue'
import DreieckGS from './forms/DreieckGS.vue'
import DreieckGSE from './forms/DreieckGSE.vue'
import DreieckRW from './forms/DreieckRW.vue'
import TrapezGS from './forms/TrapezGS.vue'
import TrapezSSR from './forms/TrapezSSR.vue'
import TrapezSSL from './forms/TrapezSSL.vue'
import TrapezSOR from './forms/TrapezSOR.vue'
import TrapezSOL from './forms/TrapezSOL.vue'
import TrapezSER from './forms/TrapezSER.vue'
import TrapezSEL from './forms/TrapezSEL.vue'
import Kreis from './forms/Kreis.vue'
import Halbkreis from './forms/Halbkreis.vue'
import Pentagon from './forms/Pentagon.vue'
import Hexagon from './forms/Hexagon.vue'
import Heptagon from './forms/Heptagon.vue'
import Oktagon from './forms/Oktagon.vue'

export default {
  data () {
    return {
      forms: DataForm.forms
    }
  },
  computed: {
    ...mapGetters([
      'formType',
      'draftFormType',
      'formComplete',
      'materialType',
      'materialColor',
      'formSize'
    ])
  },
  components: {
    Rechteck,
    DreieckGS,
    DreieckGSE,
    DreieckRW,
    TrapezGS,
    TrapezSSR,
    TrapezSSL,
    TrapezSOR,
    TrapezSOL,
    TrapezSER,
    TrapezSEL,
    Kreis,
    Halbkreis,
    Pentagon,
    Hexagon,
    Heptagon,
    Oktagon
  }
}
</script>

<style>
.kub-draft-svg {
  height: 40vh;
  min-height: 300px;
  width: 100%;
  max-width: 800px;
}

#kub-draft-summary {
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.2;
}

@media (max-width: 1200px) {
  #kub-draft-summary {
    font-size: 1rem;
  }
}

@media (min-width: 992px) {
  .kub-draft-svg {
    height: 60vh;
    min-height: 300px;
    width: 100%;
    max-width: 800px;
  }
}
</style>
